import "core-js/modules/es7.object.get-own-property-descriptors.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.object.keys.js";
import "regenerator-runtime/runtime.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es6.regexp.replace.js";
import "core-js/modules/es6.regexp.search.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import delay from 'lodash/delay';
import debounce from 'lodash/debounce';
import { mapGetters } from 'vuex';
import searchSuggestionQuery from '~/graphql/searchSuggestion.gql';
import { TIMER } from '~/const/timers';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/loupe.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/micro.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/cross.svg';
import pageActions from '~/store/modules/pageActions';
import registerStoreModule from '~/helpers/store-helper';

var SearchResults = function SearchResults() {
  return import('./SearchResults.vue');
};

var LayerFullscreen = function LayerFullscreen() {
  return import(
  /* webpackChunkName: "layer" */
  '~/components/specific/MainHeader/LayerFullscreen.vue');
};

var AlgoliaSearch = function AlgoliaSearch() {
  return import('~/components/organisms/Category/AlgoliaSearch.vue');
};

export default {
  name: 'SearchItem',
  components: {
    SearchResults: SearchResults,
    LayerFullscreen: LayerFullscreen
  },
  props: {
    hasStickedFilters: {
      type: Boolean,
      required: false
    }
  },
  data: function data() {
    return {
      algoliaSearchComponent: null,
      algoliaSearch: null,
      isOpenMenu: false,
      searchError: false,
      search: '',
      results: {
        products: [],
        total: 0
      },
      loading: false,
      searchResults: true
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters({
    locale: 'i18n/locale'
  })), {}, {
    formAction: function formAction() {
      return "/".concat(this.locale.market, "/").concat(this.locale.language, "/q/").concat(this.sanitizedSearch);
    },
    sanitizedSearch: function sanitizedSearch() {
      return this.search ? this.search.trim().replace(/[()<>[\]{}"/\\;=?.]/gi, '') : '';
    },
    totalResults: function totalResults() {
      return this.results.total;
    }
  }),
  watch: {
    search: function search() {
      this.debounceGetSuggestion();
    },
    value: function value() {
      if (this.type === 'search' && this.value === true && this.$refs.search !== undefined) {
        this.focus();
      }

      if (this.type === 'search' && !this.value) {
        this.resetForm();
      }
    }
  },
  created: function created() {
    registerStoreModule(this.$store, 'pageActions/', pageActions);
  },
  mounted: function mounted() {
    var _this = this;

    this.$root.$on('open-algolia-search', function () {
      _this.openSearch();
    });
    this.$root.$on('close-algolia-search', function () {
      _this.closeSearch(true);
    });
    this.$root.$on('close-search-results', function () {
      _this.searchResults = false;
    });
  },
  destroyed: function destroyed() {
    this.$root.$off('close-search-results');
  },
  methods: {
    openSearch: function openSearch() {
      this.algoliaSearch = this.$cookies.get('algolia') && this.locale.iso === 'fr-FR';
      var tracking = {
        data: {
          event_category: 'Header',
          event_action: 'Search',
          event_label: 'ES_Clic'
        }
      };

      if (this.algoliaSearch) {
        this.isOpenMenu = true;
        this.algoliaSearchComponent = AlgoliaSearch;
        tracking = {
          data: {
            event_category: 'Header',
            event_action: 'Search',
            event_label: 'Algolia_Clic'
          }
        };
      }

      this.$root.$emit('generic-tracking', null, tracking);
    },
    closeSearch: function closeSearch() {
      var productClicked = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      this.isOpenMenu = false;
      this.resetForm();
      var queries = {};
      this.$router.replace({
        query: queries
      });
      this.algoliaSearchComponent = null;

      if (!productClicked) {
        this.$root.$emit('generic-tracking', null, {
          data: {
            event_category: 'Header',
            event_action: 'Search',
            event_label: 'Algolia_Fermer'
          }
        });
      }

      this.$root.$emit('reset-tcvars');
    },
    debounceGetSuggestion: debounce(function getSuggestions() {
      this.getSuggestions();
    }, 200),
    focusSearchInput: function focusSearchInput() {
      var _this2 = this;

      delay(function () {
        return _this2.$refs.search.focus();
      }, 50);
    },
    handleSubmit: function handleSubmit() {
      var _this3 = this;

      this.algoliaSearch = this.$cookies.get('algolia') && this.locale.iso === 'fr-FR';

      if (this.algoliaSearch) {
        this.openSearch();
      } else {
        if (this.search === '') {
          this.searchError = true;
          delay(function () {
            _this3.searchError = false;
          }, TIMER);
        }

        this.$router.push(this.formAction);
        this.resetForm();
        this.$refs.search.blur();
        this.$emit('submitCloseMenu');
        this.$root.$emit('generic-tracking', null, {
          data: {
            event_category: 'Header',
            event_action: 'Search',
            event_label: 'ES_Entrée'
          }
        });
      }
    },
    handleInput: function handleInput(_ref) {
      var target = _ref.target;
      this.search = target.value;
      this.searchResults = true;
    },
    handleArrowUp: function handleArrowUp() {
      this.$refs.searchResults.focusLastItem();
    },
    handleArrowDown: function handleArrowDown() {
      this.$refs.searchResults.focusFirstItem();
    },
    handleLeaveViewSuggestion: function handleLeaveViewSuggestion() {
      this.$emit('hide-search-banner');
      this.resetForm();
      this.$root.$emit('hide-layer');
    },
    gotToSearch: function gotToSearch() {
      this.$root.$emit('hide-layer');
      this.$router.push(this.formAction);
      this.resetForm();
    },
    getSuggestions: function getSuggestions() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _yield$_this4$$apollo, _yield$_this4$$apollo2, categorySearch, productSearchSuggest, products, totalProducts, categories, total;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this4.sanitizedSearch) {
                  _context.next = 3;
                  break;
                }

                _this4.resetForm();

                return _context.abrupt("return");

              case 3:
                if (!(_this4.sanitizedSearch.length < 3)) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt("return");

              case 5:
                _this4.loading = true;
                _context.prev = 6;
                _context.next = 9;
                return _this4.$apolloProvider.defaultClient.query({
                  query: searchSuggestionQuery,
                  variables: {
                    locale: _this4.locale.iso,
                    keyword: _this4.sanitizedSearch,
                    offset: 0,
                    limit: 5,
                    sortBy: 'POPULAR',
                    orderBy: 'DEFAULT',
                    filterBy: []
                  }
                });

              case 9:
                _yield$_this4$$apollo = _context.sent;
                _yield$_this4$$apollo2 = _yield$_this4$$apollo.data;
                categorySearch = _yield$_this4$$apollo2.categorySearch;
                productSearchSuggest = _yield$_this4$$apollo2.productSearchSuggest;
                _this4.loading = false;
                products = productSearchSuggest.products, totalProducts = productSearchSuggest.total;
                categories = categorySearch;
                total = products.length + categories.length;
                _this4.results = {
                  query: _this4.sanitizedSearch,
                  products: products,
                  categories: categories,
                  total: total,
                  totalProducts: totalProducts
                };
                _context.next = 24;
                break;

              case 20:
                _context.prev = 20;
                _context.t0 = _context["catch"](6);
                _this4.loading = false;

                _this4.$logger.error(_context.t0);

              case 24:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[6, 20]]);
      }))();
    },
    resetForm: function resetForm() {
      this.search = '';
      this.searchError = false;
      this.results = {
        products: [],
        total: 0
      };
    },
    updateSearchValue: function updateSearchValue(keyword) {
      this.search = keyword;
    }
  }
};